
<template v-if='$store.getters.isLoggedIn'>

<div class="text-center" >
  <v-menu
    v-model="menu"
    :close-on-content-click="true"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
          dark
          class="ml-3"
          v-bind="attrs"
          v-on="on"
      >
        <img src="https://randomuser.me/api/portraits/men/88.jpg">
      </v-avatar>
    </template>

    <ProfilePopUp v-if="menu"/>

  </v-menu>
</div>

</template>



<script>

import ProfilePopUp from './ProfilePopUp'
import { bus } from '../main'

export default {
  name: 'Menu',

  created (){
    console.log('> Menu created hook..')
    bus.$on('ProfilePopUpVisible', (data) => {
      console.log('> ProfilePopUpVisible event..')
      console.log(data)
      this.menu = data;
    })
  },

  components: {
    ProfilePopUp,
  },

  data: () => ({
    menu: false,
  }),

}


</script>

